import React, { useState, useEffect } from 'react'
import { Modal, Select, Table } from 'antd'
import { FIELD_TYPES } from 'utils/importExport/externalImport'

const { Option } = Select

const truncate = (str, maxLen = 10) => {
  if (!str || str.length <= maxLen) return str
  return `${str.substring(0, maxLen)}...`
}

const ImportMappingModal = ({ visible, columns, rows, totalCount, onConfirm, onCancel, t }) => {
  const [mapping, setMapping] = useState(columns)

  useEffect(() => {
    setMapping(columns)
  }, [columns])

  const handleTypeChange = (columnName, newType) => {
    setMapping((prev) =>
      prev.map((col) => (col.column === columnName ? { ...col, type: newType } : col)),
    )
  }

  const getSampleValues = (columnName) => {
    const samples = []
    for (let i = 0; i < rows.length && samples.length < 3; i += 1) {
      const value = rows[i][columnName]
      if (value && value.trim()) {
        samples.push(value)
      }
    }
    return samples
  }

  const maskIfSensitive = (values, type) => {
    if (type === 'password' || type === 'totp') return ['●●●●']
    return values.map((v) => truncate(v))
  }

  const handleOk = () => {
    onConfirm(mapping)
  }

  const typeLabels = {
    url: t('record.result.importTypeUrl'),
    string: t('record.result.importTypeString'),
    email: t('record.result.importTypeEmail'),
    password: t('record.result.importTypePassword'),
    totp: t('record.result.importTypeTotp'),
    note: t('record.result.importTypeNote'),
    skip: t('record.result.importTypeSkip'),
  }

  const tableColumns = [
    {
      title: t('record.result.importColumnName'),
      dataIndex: 'column',
      width: 120,
    },
    {
      title: t('record.result.importFieldType'),
      dataIndex: 'type',
      width: 160,
      render: (type, record) => {
        if (type === 'title') {
          return <span>{t('record.result.importTitleFixed')}</span>
        }
        return (
          <Select
            value={type}
            onChange={(val) => handleTypeChange(record.column, val)}
            size="small"
            style={{ width: 140 }}
          >
            {FIELD_TYPES.filter((ft) => ft.value !== 'title').map((ft) => (
              <Option key={ft.value} value={ft.value}>
                {typeLabels[ft.value] || ft.value}
              </Option>
            ))}
          </Select>
        )
      },
    },
    {
      title: t('record.result.importPreview'),
      dataIndex: 'column',
      render: (columnName, record) => {
        const samples = getSampleValues(columnName)
        const masked = maskIfSensitive(samples, record.type)
        return (
          <span style={{ color: '#999', fontSize: 12 }}>
            {masked.join(', ') || '-'}
          </span>
        )
      },
    },
  ]

  return (
    <Modal
      title={t('record.result.importMappingTitle', { count: totalCount })}
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText={t('topBar.profileMenu.import')}
      cancelText={t('common.button.cancel')}
      width={640}
      destroyOnClose
    >
      <Table
        size="small"
        pagination={false}
        scroll={{ y: 360 }}
        dataSource={mapping.map((col, i) => ({ ...col, key: i }))}
        columns={tableColumns}
      />
    </Modal>
  )
}

export default ImportMappingModal
